<div class="submit-container">
  <ul class="list-unstyled mt-3 mb-4">
    <ap-radio-group [ariaLabel]="'Submission environment'" [(ngModel)]="envType" name="listName">
      <li>
        <ap-radio
          [value]="TEST"
          [styleClass]="'col-md-6 submission-radio'"
          (onChange)="envSelected('TEST')"
        ><span>{{TEST}}</span></ap-radio>
      </li>
      <li>
        <ap-radio
          [value]="PRODUCTION"
          [styleClass]="'col-md-6 submission-radio'"
          (onChange)="envSelected('PRODUCTION')"
        ><span>{{PRODUCTION}}</span></ap-radio>
      </li>
    </ap-radio-group>
  </ul>
  <div class="buttons">
    <ap-button
      [btnType]="'primary'"
      [label]="btnSubmit"
      class="ap-mt-spacing-3"
      [btnSize]="'large'"
      (onClick)="submit()"
    >
    @if (submitting) {
<ap-loading [loadingType]="'circular'" [indeterminate]="true" [compact]="true"></ap-loading>
}
    </ap-button>
    {{submission.SUBMISSION_ID}}
    <ap-button
      [btnType]="'secondary'"
      [label]="btnPingText"
      class="ap-mt-spacing-3 ap-ml-spacing-3"
      (onClick)="pingIRS()"
      [btnSize]="'large'"
    >
    @if (pinging) {
<ap-loading [loadingType]="'circular'" [indeterminate]="true" [compact]="true"></ap-loading>
}
    </ap-button>
    <ap-button
      [btnType]="'secondary'"
      [label]="btnAck"
      class="ap-mt-spacing-3 ap-ml-spacing-3"
      (onClick)="pollAck()"
      [btnSize]="'large'"
    >
    @if (acking) {
<ap-loading [loadingType]="'circular'" [indeterminate]="true" [compact]="true"></ap-loading>
}
    </ap-button>
  </div>
</div>
